var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedInsights(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 151.6 151.6",
    style: {
      enableBackground: "new 0 0 151.6 151.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2DB793;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BlackPearl-Icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.3,137.9h32.9c5.6,0,5.6-8.7,0-8.7H59.3C53.8,129.2,53.8,137.9,59.3,137.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.5,151.1h28.5c5.6,0,5.6-8.7,0-8.7H61.5C56,142.5,56,151.1,61.5,151.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,9.2L73.9,51.1c-1.4,0.9-1.7,2.8-0.8,4.2s2.8,1.7,4.2,0.8c0.3-0.2,0.5-0.4,0.7-0.6l0,0L120,9.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.3,43c3-8.6,9.5-15.6,17.8-19.2l-1.9-5.2C51.2,22.8,43.5,31.2,40,41.5L45.3,43z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.4,46.2l-5.3-1.5c-1.7,7.3-1.3,14.9,1.3,21.9l5.2-1.9C43.4,58.7,43,52.3,44.4,46.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,24.9L95,21c-9.3-5.5-20.4-6.8-30.7-3.5l1.9,5.2C74.4,20.1,83.2,20.9,90.7,24.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.5,22.5l-5.5,6.1c11.5,17,9.1,39.8-5.7,54.1c-9.3,9.1-15.4,21-17.1,33.9H61.7c-1.7-12.9-7.8-24.8-17.1-33.9 c-16.9-16.4-17.3-43.4-0.9-60.3c0.3-0.3,0.6-0.6,0.9-0.9c8.3-8.2,19.6-12.8,31.3-12.8c8.7,0,17.3,2.5,24.6,7.3l6-5.4 C85.5-4,57.1-1.8,38.8,16.1c-20,19.3-20.5,51.2-1.2,71.2c0.4,0.4,0.8,0.8,1.2,1.2c8.3,7.9,13.5,18.5,14.8,29.9 c0.3,2.1,2.6,6.3,6.6,6.3H91c4,0,6.5-4.2,6.6-6.3c1.5-11.3,6.7-21.9,14.8-29.9C130.8,71.1,133.4,42.8,118.5,22.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedInsights);
export default __webpack_public_path__ + "static/media/selected-insights.55aa87272a893237c821838646e936a4.svg";
export { ForwardRef as ReactComponent };